import { connect } from 'react-redux'
import HomePage from '../HomePage'

const mapStateToProps = (state) => {
  return {
    userLogged: state.imarReducer.user.logged
  }
}
export default connect(mapStateToProps, null)(HomePage)
